import { TimeFrameEnum } from './enums/timeframeenum';

export class ConstructionDeliveryReportParams {
    marketId: number;
    communityIds: number[];
    masterTaskId: number = null;
    startDate: Date;
    reportTimeFrame: TimeFrameEnum;
    reportDuration: number;
    fileFormat: string;
}